<div class="container">
    <div class="left-area">
        <div class="submitter-head" [style.background-color]="getBackgroundColorById(comment.submitter.id)">
            {{getAbbrNameForOneEntity()}}
        </div>
    </div>
    <div class="right-area">
        <div class="content-area" [ngClass]="{'has-child':hasChild()}">
            <div class="submitter-name">{{comment.submitter.name}}</div>
            <div class="comment-content">{{comment.comment}}</div>
            <div class="action-area" #anchor>
                <div class="reply-action" (click)="reply($event)">Reply</div>
                <div class="comment-date">{{comment.submittedDate|date}}</div>
            </div>
            <kendo-popup [anchor]="anchor" [style.display]="showPopup?'':'none'">
                <div class="comment-container">
                    <div class="text-area">
                        <textarea maxlength="500" #commentArea [(ngModel)]="content"></textarea>
                    </div>
                    <div class="function-area">
                        <div class="text-info">{{content.length}}/500</div>
                        <div class="button-area">
                            <button tam-button tamType="secondary" tamSize="normal"
                                (click)="onClickCancel($event)">Cancel</button>
                            <button tam-button tamType="primary" tamSize="normal"
                                (click)="onClickSave($event)">Save</button>
                        </div>
                    </div>
                </div>
            </kendo-popup>
        </div>
        <div class="child-area" *ngIf="hasChild()">
            <tam-comments [comments]="comments" [parentId]="comment.id" [config]="config"></tam-comments>
        </div>
    </div>
</div>